import React, { Component } from 'react'
import services from '../../../../services'
import moment from 'moment'

import { Button } from '@progress/kendo-react-buttons'

class DadosEntidade extends Component {
    state = {

    }

    // componentDidMount() {
    //     this.getEntityDetails()
    // }
    // getEntityDetails = async() => {
    //     let res = await services.apiCall.requestApi()
    // }
    estatutosRender=()=>{
        return (this.props.estatutosRes.map((key,index)=>{
            return (<>
                <span className="border p-1 mr-3 mb-2 text-center" style={{minWidth:"25%"}} key={index}>{key}</span>
            </>)
        }))
    }
    
    render() {
        let row = this.props.row
        let {entityDetail} = this.props
        let {estatutosRes} = this.props;

        return (
            <div>
               <div className="upper-information mt-3">
                    
                    <div style={{marginRight:"30%"}} className="my-3 ml-3 d-flex k-justify-content-between">
                        <div className="mr-4">
                            <label><strong>Nº entidade</strong></label>
                            <p>{row['idEntidade']}</p>
                        </div>

                        <div style={{marginRight:"125px"}}>
                            <Button primary={true}>Ficha de Entidade</Button>
                        </div>
                    </div>

                    <div className="col-md-12 my-2">
                        <label><strong>Entidade</strong></label>
                        <p>{row['Entidade']}</p>
                    </div>

                    <div className="col-md-12 my-2">
                        <label><strong>Telefone</strong></label>
                        <p>{entityDetail.telephone || "ND"}</p>
                    </div>

                    <div className="col-md-12 my-2">
                        <label><strong>Fax</strong></label>
                        <p>{entityDetail.fax || "ND"}</p>
                    </div>

                    <div className="col-md-12 my-2">
                        <label><strong>Email</strong></label>
                        <p>{entityDetail.email || "ND"}</p>
                    </div>

                    <div className="col-md-12 my-2">
                        <label><strong>Observações</strong></label>
                        <p>{row['observacaoAprovacao']}</p>
                    </div>

                    <div className="col-md-12 my-2">
                        <label><strong>Estatutos</strong></label>
                        { estatutosRes &&
                            <div className="d-flex w-25 flex-wrap">
                                {
                                    this.estatutosRender()
                                }
                            </div>
                        }
                    </div>
               </div>

                {/* <div className="first-table col-md-12 mt-3">
                    <p>Saldo - Selos impressos</p>
                    <table className="w-100 text-center">
                        <thead className="border">
                            <tr className="d-flex justify-content-around py-2">
                                <td className="w-25"><strong>Tipo</strong></td>
                                <td className="w-25"><strong>Nº de selos disponiveis</strong></td>
                                <td className="w-25"><strong>{""}</strong></td>
                            </tr>
                        </thead>
                        <tbody className="border">
                            <tr className="d-flex justify-content-around py-2">
                                <td className="w-25">{row['tipoSelo']}</td>
                                <td className="w-25">{row['selosRestantes']}</td>
                                <td className="w-25">{""}</td>
                            </tr>
                        </tbody>
                    </table>
                </div> */}

                <div className="second-table col-md-12 mt-3">
                    <p>Saldo - Séries de selos</p>
                    <table className="w-100 text-center">
                        <thead className="border">
                            <tr className="d-flex justify-content-around py-2">
                                <td className="w-25"><strong>Nº série</strong></td>
                                <td className="w-25"><strong>disponíveis</strong></td>
                                <td className="w-25">{""}</td>
                            </tr>
                        </thead>
                        <tbody className="border">
                            {
                                this.props.entityBalanceSeries.length > 0 ?
                                (this.props.entityBalanceSeries.map(serie => (
                                <tr className="d-flex justify-content-around py-2 border">
                                    <td className="w-25">{serie['controle']}</td>
                                    <td className="w-25">{serie['selosRestantes']}</td>
                                    <td className="w-25">{""}</td>
                                </tr>
                                ))) 
                                : 
                                (
                                    <tr>
                                        <td colSpan="5">Sem resultados</td>
                                    </tr>
                                )
                            }
                            
                        </tbody>
                    </table>
                </div>

                <div className="third-table col-md-12 mt-3">
                    <p>Pedidos semelhantes</p>
                    <table className="w-100 text-center">
                        <thead className="border">
                            <tr className="d-flex justify-content-around py-2">
                                <td className="w-25"><strong>Data</strong></td>
                                <td className="w-25"><strong>Tipo de pedido</strong></td>
                                <td className="w-25"><strong>Estado</strong></td>
                            </tr>
                        </thead>
                        <tbody className="border">
                            {
                                this.props.entityPendingOrders.length > 0 ?
                                this.props.entityPendingOrders.map(order => (
                                <tr className="d-flex justify-content-around py-2">
                                    <td className="w-25">{moment(order['date']).format('DD/MM/YY')}</td>
                                    <td className="w-25">{order['tipoPedido']}</td>
                                    <td className="w-25">{"Pendente"}</td>
                                </tr>
                                ))
                                :
                                (
                                    <tr>
                                        <td colSpan="5">Sem dados a apresentar</td>
                                    </tr>
                                )
                                
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default DadosEntidade